<!-- Sidepanel Left -->
@if(isDraggable){
<div cdkDrag class="draggable-wrapper">
  <ng-content *ngTemplateOutlet="rightSidePanel"></ng-content>
</div>
}
<ng-content *ngTemplateOutlet="!isDraggable ? rightSidePanel : null"></ng-content>

<ng-template #rightSidePanel>
  @if(navService.getSideNav('right')){
  <aside class="secondary-sidepanel"
    [ngClass]="{ 'secondary-sidepanel--draggable secondary-sidepanel--draggable-compact': isDraggable, 'secondary-sidepanel--compact': isCompact, 'secondary-sidepanel--compact-collapsed': isCompact && !navService.getSideNav('right'), 'secondary-sidepanel--revised': themeService.selectedDialpadTheme.tab === themeService.DialpadTheme.NEUMORPHIC }"
    @openClose>


    <div class="secondary-sidepanel__header">
      @if(isDraggable){
      <div class="close-icon" (click)="onCloseDialpad()"><i class="fa-solid fa-xmark-large"></i>
      </div>
      }
      <div class="icon-based-tabs-wrapper">
        <!-- Icon Based Tabs -->
        <div class="icon-based-tabs"
          [ngClass]="themeService.selectedDialpadTheme.tab === themeService.DialpadTheme.NEUMORPHIC ? ' icon-based-tabs--secondary icon-based-tabs--neumorphic' : ''">
          <ul class="icon-based-tabs__content">
            <li>
              <a (click)="navService.setRightSideRoute(navService.RightSideNavRoutes.DIALPAD)"
                [ngClass]="{ active: navService.getRightSideRoute() === navService.RightSideNavRoutes.DIALPAD, 'disabled' : !telephonyStateService.onCall }">
                <svg width="16" height="17" viewBox="0 0 16 17" fill="#000" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.420898" y="0.84375" width="4" height="4" rx="2" />
                  <rect x="0.420898" y="6.65625" width="4" height="4" rx="2" />
                  <rect x="6.0791" y="0.84375" width="4" height="4" rx="2" />
                  <rect x="6.0791" y="6.65625" width="4" height="4" rx="2" />
                  <rect x="6.0791" y="12.1562" width="4" height="4" rx="2" />
                  <rect x="11.5791" y="0.84375" width="4" height="4" rx="2" />
                  <rect x="11.5791" y="6.65625" width="4" height="4" rx="2" />
                </svg><span>DialPad</span></a>
            </li>

            <li>
              <a (click)="navService.setRightSideRoute(navService.RightSideNavRoutes.INFO)"
                [ngClass]="{ active: navService.getRightSideRoute() === navService.RightSideNavRoutes.INFO, 'disabled' : !telephonyStateService.onCall }"><i
                  class="fa-light fa-circle-info"></i><span>Info </span></a>
            </li>
            <li>
              <a (click)="navService.setRightSideRoute(navService.RightSideNavRoutes.VERBIAGE)"
                [ngClass]="{ active: navService.getRightSideRoute() === navService.RightSideNavRoutes.VERBIAGE, 'disabled' : !telephonyStateService.onCall }"><i
                  class="fa-light fa-light fa-right-left"></i><span>Verbiage</span></a>
            </li>
            @if(this.campaignService.showNotes){
              <li>
                <a (click)="navService.setRightSideRoute(navService.RightSideNavRoutes.NOTE)"
                  [ngClass]="{ active: navService.getRightSideRoute() === navService.RightSideNavRoutes.NOTE, 'disabled' : !telephonyStateService.onCall }"><i
                    class="fa-light fa-calendar-circle-user"></i><span>Note</span></a>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>

    <div class="secondary-sidepanel__content">
      <ng-scrollbar style="height: calc(100vh - 160px);">
        <!-- [ngStyle]="{'min-height': isCompact ? '415px': '466px'}" -->
        @if(navService.getRightSideRoute() === navService.RightSideNavRoutes.DIALPAD){
        <app-dial-pad></app-dial-pad>
        }
        @if(navService.getRightSideRoute() === navService.RightSideNavRoutes.INFO){
        <app-contact-info></app-contact-info>
        }
        @if(navService.getRightSideRoute() === navService.RightSideNavRoutes.VERBIAGE){
        <app-verbiage></app-verbiage>
        }
        @if(navService.getRightSideRoute() === navService.RightSideNavRoutes.NOTE && this.campaignService.showNotes){
        <app-notes></app-notes>
        }
        <!-- <app-call-feedback
      *ngIf="navService.getRightSideRoute() === navService.RightSideNavRoutes.VERBIAGE"></app-call-feedback> -->
      </ng-scrollbar>
    </div>

  </aside>
  }
</ng-template>